// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCustomerOrdersByIdRequestModel from '../../model/get-customer-orders-by-id-request-model';
import GetCustomerOrdersByIdRequestDTO from '../dto/get-customer-orders-by-id-request-dto';

export default abstract class GetCustomerOrdersByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCustomerOrdersByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  'id'?: number;

  static toModel(dto: DeepPartial<GetCustomerOrdersByIdRequestDTO>): GetCustomerOrdersByIdRequestModel;
  static toModel(dto: DeepPartial<GetCustomerOrdersByIdRequestDTO> | undefined | null): GetCustomerOrdersByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCustomerOrdersByIdRequestDTO> | undefined | null): GetCustomerOrdersByIdRequestModel | undefined {
    return dto ? new GetCustomerOrdersByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCustomerOrdersByIdRequestModel> | GetCustomerOrdersByIdRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'id': unwrapped.id,
    } as GetCustomerOrdersByIdRequestDTO;
  }
}
